// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../css-loader/index.js?minimize!../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4a6ac118\",\"scoped\":false,\"hasInlineConfig\":false}!./vue-multiselect.min.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../vue-style-loader/lib/addStylesClient.js")("6d8bad2c", content, true);


//////////////////
// WEBPACK FOOTER
// ./~/vue-style-loader!./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4a6ac118","scoped":false,"hasInlineConfig":false}!./~/vue-multiselect/dist/vue-multiselect.min.css
// module id = 110
// module chunks = 0 1